module.exports = __webpack_public_path__ + "img/code.79849f80.png";